export const COLORS = {
  black: '#000',
  white: '#fff',
  green: '#34FCA4',
  grey: '#F2F2F2',
  darkGrey: '#a9a9a9',
};

export const SIZES = {
  xs: '8px',
  sm: '12px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '40px',
};

export const FONT_SIZES = {
  xs: '11px',
  sm: '14px',
  md: '18px',
  lg: '30px',
  xl: '40px',
};
